const AppConfig = {
  API_BASE_URL: 'https://lms.coderslab.si/lms-api',
  PUBLIC_API_BASE_URL: 'https://lms.coderslab.si/public-api',
  SENTRY_DSN: 'https://571412cabd4d474783f46ab4ba0bd33c@o203382.ingest.sentry.io/4505153815445504',
  LANG: 'en',
  HUB_URL: 'https://dev-berta.coderslab.pl',
  SHOW_GRADEBOOK_TAB: 1,
  LOGIN_REDIRECT_URL: 'https://lms.coderslab.si/auth/github_connect?redirect_url=',
  COURSE_ICON_BASE_URL: 'https://lms.coderslab.si/',
  TENANT_USER_LANGUAGES: 'pl,en',
  FEATURE_MATERIAL_ISSUE: 0,
  LOGO: '',
  COURSES_CATALOG_URL: '',
  CONTACT_URL: '',
  USER_ENGAGE_API_KEY: '',
  USER_ENGAGE_SCRIPT_URL: '',
};

export default AppConfig;
